// Keep the booking in its normal centered dialog. The guide partially overlaps
// its lower-right area, staying inside the viewport so navigation is reachable.
export function getAppointmentGuidePosition(rect, viewportWidth, viewportHeight, panelHeight) {
  const width = Math.min(380, viewportWidth - 32);
  return {
    left: Math.max(16, Math.min(rect.left + rect.width * 0.65, viewportWidth - width - 16)),
    top: Math.max(16, Math.min(rect.top + rect.height * 0.55, viewportHeight - panelHeight - 16)),
  };
}
